import { CustomerSentOrdersResponseNormalized } from '../../../../../../store/customerDetail/types';
import { handleExportNewOrder } from '../../../../../OrdersHistory/Container/components/OrderHistoryItem/constants';

type ComponentBreakpoint = 'desktop' | 'tablet';

export const rowHeight: { [K in ComponentBreakpoint]: number } = { desktop: 74, tablet: 84 };

export const tableHead = {
  document: '#',
  orderId: 'Ordem',
  sentDate: 'Data de Envio',
  customerName: 'Clientes',
  account: 'Conta',
  product: 'Produto',
  sentValue: 'Total enviado',
  status: 'Status',
  details: '',
};

export const tableHeadAlignments: Partial<
  Record<keyof typeof tableHead, 'left' | 'center' | 'right'>
> = {
  sentValue: 'center',
};

export const widthCols: Record<keyof typeof tableHead, { [K in ComponentBreakpoint]: number }> = {
  document: { desktop: 5, tablet: 5 },
  orderId: { desktop: 10, tablet: 10 },
  sentDate: { desktop: 10, tablet: 10 },
  customerName: { desktop: 17, tablet: 17 },
  account: { desktop: 8, tablet: 10 },
  product: { desktop: 15, tablet: 15 },
  sentValue: { desktop: 13, tablet: 13 },
  status: { desktop: 12, tablet: 15 },
  details: { desktop: 10, tablet: 5 },
};

export const handleExportSentOrder = (item: CustomerSentOrdersResponseNormalized) => {
  handleExportNewOrder(item);
};
